import { render, staticRenderFns } from "./Nature.vue?vue&type=template&id=9b99d12c"
var script = {}
import style0 from "./Nature.vue?vue&type=style&index=0&id=9b99d12c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports